export default __webpack_public_path__ + "static/icon-20-1-fd1a763a43d8707a27d8f2c9d6cdf36f.png";